export interface ISwapQualityIssueForList {
    id: number,
    swapInfo: string,
    donorCenterId: number,
    donorCenter: string,
    rdnCenterId: number,
    rdnCenterAlias: string,
    donorId: number,
    donorAlias: string,
    donorAbo: string,
    donorAge: number,
    recipientCenterId: number,
    recipientCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientAbo: string,
    recipientAge: number,
    recipientWaitTime: number,
    shipmentMethod: string,
    donorSurgeon: string,
    recipientSurgeon: string,
    isFinalized: boolean,
    hasIssues: boolean,
    isLatePickup: boolean,
    isRecipientCenter: boolean
}